import { useMemo } from "react"

import { MeetingServicePriceListStatus } from "../createOrderTypes"

export type MeetingServicePriceListStatusFlags = Readonly<{
    isUnselected: boolean
    isValidating: boolean
    isReady: boolean
    isNoProducts: boolean
    isError: boolean
    isNoProductsOrError: boolean
}>

export function getMeetingServicePriceListStatusFlags(
    status: MeetingServicePriceListStatus,
): MeetingServicePriceListStatusFlags {
    const isUnselected = status === MeetingServicePriceListStatus.UNSELECTED
    const isValidating = status === MeetingServicePriceListStatus.VALIDATING
    const isReady = status === MeetingServicePriceListStatus.READY
    const isNoProducts = status === MeetingServicePriceListStatus.NO_PRODUCTS
    const isError = status === MeetingServicePriceListStatus.ERROR

    return {
        isUnselected,
        isValidating,
        isReady,
        isNoProducts,
        isError,
        isNoProductsOrError: isNoProducts || isError,
    }
}

export function useMeetingServicePriceListStatus(
    status: MeetingServicePriceListStatus,
): MeetingServicePriceListStatusFlags {
    return useMemo(() => getMeetingServicePriceListStatusFlags(status), [status])
}
